import { render, staticRenderFns } from "./PFHTModal.vue?vue&type=template&id=53b42c47&scoped=true"
import script from "./PFHTModal.vue?vue&type=script&lang=js"
export * from "./PFHTModal.vue?vue&type=script&lang=js"
import style0 from "./PFHTModal.vue?vue&type=style&index=0&id=53b42c47&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b42c47",
  null
  
)

export default component.exports